import { formatMoney } from '@shopify/theme-currency';
import React from 'react';
import { useQuery } from 'react-query';
import { getRecommendedProducts } from '../../../hooks/useProduct';
import ResponsiveImage from '../../parts/ResponsiveImage';

const Recommendations = (props) => {
  const { product: productId } = props;
  const { isLoading, isError, data: products, error } = useQuery(['recommendations', { productId }], getRecommendedProducts);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError) {
    return <div>Could not retrieve products. Please try again later.</div>;
  }

  let filteredProducts = products?.filter((item) => !item.title.includes('Route') && !item.title.includes('Package Protection'));

  return (
    <div className="Loop">
      {filteredProducts.slice(0, 4).map((product) => {
        return (
          <div className="Card" data-type="product" data-layout="vertical media-content">
            <figure className="Card__media">
              <a href={`/products/${product.handle}`}>
                <ResponsiveImage image={product.featured_image} title={product.title}></ResponsiveImage>
              </a>
            </figure>
            <div className="Card__content">
              <h4 className="Card__title">
                <a href={`/products/${product.handle}`}>{product.title}</a>
              </h4>
              <div className="options">
                <p className="price">{formatMoney(product.price)}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Recommendations;
